import { DatiIntegrativiTrascrizione, SectionVM } from 'civil-status/view-models/step-form';

export const transformerDatiIntegrativiTrascrizione = (
  idEvento?: number,
  dataSection?: SectionVM
): DatiIntegrativiTrascrizione | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    nomeRedattore: dataSection.nameEditor || undefined,
    cognomeRedattore: dataSection.surnameEditor || undefined,
    sesso: dataSection.gender || undefined,
    numeroOraDocumento: dataSection.timeDocumentFormation
      ? dataSection.timeDocumentFormation.toFormat('HH')
      : undefined,
    numeroMinutoDocumento: dataSection.timeDocumentFormation
      ? dataSection.timeDocumentFormation.toFormat('mm')
      : undefined,
    motivoDelega: dataSection.reason || undefined,
    descrizioneUfficialeDelegante: dataSection.ufcDelegate || undefined,
  };
};
